import request from '@/utils/request';
// 获取微信重点传播任务列表
export function get_wechat_propagate_task(data) {
  return request({
    url: '/wap/index/get_wechat_propagate_task',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}

// 获取第三方活动列表
export function getExternalActivitiesLists(data) {
  return request({
    url: '/wap/index/get_external_activities_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取第三方商品列表
export function getExternalGoodsLists(data) {
  return request({
    url: '/wap/index/get_external_goods_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取首页信息【签到信息、活动信息、第三方推荐活动、第三方商品】
export function getHomeInfo(data) {
  return request({
    url: '/wap/index/get_home_info',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取月份任务列表
export function getMonthTaskInfo(data) {
  return request({
    url: '/wap/index/get_month_task_info',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取人员重点传播任务
export function getPropagateTask(data) {
  return request({
    url: '/wap/index/get_propagate_task',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 点击重点传播任务
export function clickPropagateTask(data) {
  return request({
    url: '/wap/index/click_propagate_task',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 签到接口
export function sign(data) {
  return request({
    url: '/wap/index/sign',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取部门接口
export function getDeptLists(data) {
  return request({
    url: '/wap/index/get_dept_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 绑定部门接口
export function bindDept(data) {
  return request({
    url: '/wap/index/bind_dept',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}

// 获取用户信息
export function get_member_info(data) {
  return request({
    url: '/wap/index/get_member_data',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}